/**
 * The app nav's height: one source for the fixed bar itself (`NavMenuBar`), the content offset
 * under it (`AdminStyles.Container`) and anything that sticks just below it (STFFLG-4131's sticky
 * order summary uses it as its `top`).
 *
 * px, not rem, on purpose: this is the existing bar's height, kept byte-identical (STFFLG-4131 D7:
 * the nav does not change). It is the same at every window width; the nav swaps its items for a
 * menu below its own breakpoint, but never its height.
 */
export const APP_NAV_HEIGHT_PX = 70

/** `APP_NAV_HEIGHT_PX` as a CSS length, for styled-components. */
export const APP_NAV_HEIGHT = `${APP_NAV_HEIGHT_PX}px`

/**
 * The width below which the page wrapper and the nav narrow their sides from 32px to 16px
 * 32px at 1000px and wider, 16px at 999px and narrower. A max-width media query
 * value. (The nav's own menu-swap breakpoint is a separate, unchanged value.)
 */
export const APP_PAGE_SIDE_NARROW_MAX = '999px'

/** The page wrapper's and the nav's side padding at 1000px and wider: 32px. */
export const APP_PAGE_SIDE = 'var(--space-8)'

/** The same below 1000px: 16px. */
export const APP_PAGE_SIDE_NARROW = 'var(--space-4)'
